import { useRef, useState, useEffect } from 'react';
import '../styles/login.css';
import nuwAILogo from '../assets/NuwAI@2x.png';

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/msalConfig";

export default function LoginScreen() {
    const { instance } = useMsal();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const timeout = async (delay) => {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleLogin = async (loginType) => {
        setAnchorEl(null);

        try {
            await instance.loginPopup({
                ...loginRequest,
                redirectUri: process.env.REACT_APP_POPUP_REDIRECT_URI,
            });
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <div className="abacus-login-container">
                <div className="abacus-login-header">
                    <img src={nuwAILogo} alt="NuwAI" className="ai-logo login" />
                </div>
                <div className="abacus-login-body">
                    <button onClick={() => handleLogin("popup")} type="submit" className="abacus-login-btn"><p alt="Enter" className="ai-login-enter">Login</p></button>
                </div>
            </div>
        </>
    );
}